// removed by extract-text-webpack-plugin
module.exports = {"selected-date-range":"selected-date-range","selected-date":"selected-date","selected-date-delimiter":"selected-date-delimiter"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/dashboard/component/selected-date-range/selected-date-range.style.sass
// module id = WGcY
// module chunks = 0